import { TABLES_KEYS } from 'features/command-center/constants';
import strings from 'strings';
import { DateFormats } from 'UI/constants/defaults';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { hasFeatureFlag, localTimeFormatter } from 'UI/utils';

export const PAGE_KEY = TABLES_KEYS.feedbackNotes;

export const COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'userId',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'reachOutReasonTitle',
    label: 'Reason to Reach Out',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'formattedAddressableIssues',
    label: 'Issues to Address',
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'multipleChipBuilder',
        config: {
          idKey: 'id',
          labelKey: 'title'
        }
      },
      setCellHeaderProps: () => ({
        style: { minWidth: 250 }
      })
    }
  },
  {
    name: 'descriptionExcerpt',
    label: 'Summary',
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => ({
        style: { minWidth: 250 }
      })
    }
  },
  {
    name: 'description',
    label: 'Description',
    options: {
      sort: false,
      display: false,
      renderer: 'html',
      setCellHeaderProps: () => ({
        style: { minWidth: 400 }
      })
    }
  },
  {
    name: 'contract',
    label: 'Contract',
    options: {
      sort: true,
      display: true,
      renderer: {
        id: 'trimText'
      }
    }
  },
  {
    name: 'createdAt',
    label: 'Created on',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'updatedAt',
    label: 'Last Updated on',
    options: {
      sort: true,
      display: true,
      renderer: 'date'
    }
  },
  {
    name: 'createdBy.fullName',
    label: 'Added By',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'updatedBy.fullName',
    label: 'Updated By',
    options: {
      sort: true,
      display: true
    }
  },
  {
    name: 'employeeFile',
    label: strings.commandCenter.feedbackNotes.savedInEmployeeFileAt.columnLabel,
    options: {
      sort: false,
      display: hasFeatureFlag(FeatureFlags.FeedbackNotesSaveInEmployeeFile) ? false : 'excluded',
      renderer: value =>
        value?.lastSavedToEmployeeFileResult &&
        localTimeFormatter(value.lastSavedToEmployeeFileResult, DateFormats.SimpleDateTime)
    }
  }
];

export const ORDER_BY_OPTIONS = {
  column: 'createdAt',
  direction: 'desc'
};
